// window.* is used for production build version where environment variables provided are from pre-rendered on backend site index.html that is setting window.* variables
// import.meta.env.* is used when using vite build with hot module reload mode improving development experience

export type ConfigProps = {
  env: {
    API_URL: string
    REACT_APP_WEB_REDIRECT_URI: string
    REACT_APP_DESKTOP_REDIRECT_URI: string
    REACT_APP_AUTHORITY: string
    REACT_APP_CLIENT_ID: string
    REACT_TEAMS_VAYU_APP_URL: string
    APPLICATIONINSIGHTS_CONNECTION_STRING: string
    CORRELATION_ID: string,
    HVDC_ACADEMY_APP_URL: string,
    TRAFOCHAT_TUTORIAL_URL: string
    PROJECT_NAVIGATOR_URL: string
    TAIJU_APP_URL: string
    NEW_ARCHITECT_URL: string
    NEW_ARCHITECT_LIVE: boolean
    REACT_APP_TRUSTED_IFRAME_ORIGINS: string
  }
}

// Prioritize window.* config over import.meta.env.* config as window.* is used for production build and import.meta.env.* is used for development build.
// This allows us to have different config values for development (using Vite Server and HMR) and production like environments without needing to change code.
const resolveValue = <K extends keyof ConfigProps['env']>(key: K): string => {
  const windowValue = (window as any)[key]
  if (windowValue && !windowValue.startsWith('{{')) {
    return windowValue
  }

  const metaValue = import.meta.env[key]
  if (metaValue) {
    return metaValue
  }

  return ''
}

export const config: ConfigProps = {
  env: {
    API_URL: resolveValue('API_URL'),
    REACT_APP_WEB_REDIRECT_URI: resolveValue('REACT_APP_WEB_REDIRECT_URI'),
    REACT_APP_DESKTOP_REDIRECT_URI: resolveValue('REACT_APP_DESKTOP_REDIRECT_URI'),
    REACT_APP_AUTHORITY: resolveValue('REACT_APP_AUTHORITY'),
    REACT_APP_CLIENT_ID: resolveValue('REACT_APP_CLIENT_ID'),
    REACT_TEAMS_VAYU_APP_URL: resolveValue('REACT_TEAMS_VAYU_APP_URL'),
    APPLICATIONINSIGHTS_CONNECTION_STRING: resolveValue('APPLICATIONINSIGHTS_CONNECTION_STRING'),
    CORRELATION_ID: resolveValue('CORRELATION_ID'),
    HVDC_ACADEMY_APP_URL: resolveValue('HVDC_ACADEMY_APP_URL'),
    TRAFOCHAT_TUTORIAL_URL: resolveValue('TRAFOCHAT_TUTORIAL_URL'),
    PROJECT_NAVIGATOR_URL: resolveValue('PROJECT_NAVIGATOR_URL'),
    TAIJU_APP_URL: resolveValue('TAIJU_APP_URL'),
    NEW_ARCHITECT_URL: resolveValue('NEW_ARCHITECT_URL'),
    NEW_ARCHITECT_LIVE: resolveValue('NEW_ARCHITECT_LIVE') === 'true',
    REACT_APP_TRUSTED_IFRAME_ORIGINS: resolveValue('REACT_APP_TRUSTED_IFRAME_ORIGINS')
  }
}
